import { ITimestamp } from "../../../components/TimestampsSelector/timestamps";
import { ICalculation, priorityOptions } from "../../../models/calculation";
import { ValidationProcess } from "../../../store/validationProcess";
import { verticesSelectionOptions } from "../../../store/verticesReducer";

const formatDate = (dateString: string, hours: boolean) => {
    if (hours) return dateString.replace("T", " ").substring(0, dateString.indexOf("."));
    else return dateString.substring(0, dateString.indexOf("T"));
};

export const formatPriority = (opt: number) => {
    return priorityOptions.filter(x => x.key === opt)[0].text;
};

/*
const formatTimestamps = (timestamps: number[]) => {
    const timestampsStrings: string[] = [];
    timestamps.forEach(x => timestampsStrings.push(x.toString().padStart(2, "0") + ":30"));
    return timestampsStrings.join(", ");
};
*/
const formatTimestamps = (activeTimestamps: ITimestamp[]) => {
    const timestampsStrings: string[] = [];
    activeTimestamps?.forEach(x => timestampsStrings.push(x.text));
    return timestampsStrings.join(", ");
};

const formatVertexSelection = (opt: number) => {
    if (opt === -1) return "Manual mode";
    else return verticesSelectionOptions.filter(x => x.key === opt)[0].text;
};

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsGeneralInfo = ({ calculation }: IProps) => {
    let validationProcessString = "Unknown";
    if (calculation.validationProcess === ValidationProcess.DayAhead) {
        validationProcessString = "DA CCV";
    }
    else if (calculation.validationProcess === ValidationProcess.IntraDay) {
        validationProcessString = "ID CCV";
    }
    else if (calculation.validationProcess === ValidationProcess.Ltcc) {
        validationProcessString = "LT CCV";
    }

    return (
        <>
            <p id="p-CalcPropsGeneralInfo-a">
                <label id="label-CalcPropsGeneralInfo-a">User: </label>
                {calculation.message}
            </p>
            <p id="p-CalcPropsGeneralInfo-b">
                <label id="label-CalcPropsGeneralInfo-b">Created: </label>
                {formatDate(calculation.calculationDate, false)}
            </p>
            <p id="p-CalcPropsGeneralInfo-c">
                <label id="label-CalcPropsGeneralInfo-c">Started: </label>
                {formatDate(calculation.started, true)}
            </p>
            <p id="p-CalcPropsGeneralInfo-d">
                <label id="label-CalcPropsGeneralInfo-d">Priority: </label>
                {formatPriority(calculation.priority)}
            </p>
            <p id="p-CalcPropsGeneralInfo-e">
                <label id="label-CalcPropsGeneralInfo-e">Business process: </label>
                {validationProcessString}
            </p>
            <p id="p-CalcPropsGeneralInfo-f">
                <label id="label-CalcPropsGeneralInfo-f">Selected TSO: </label>
                {calculation.tsos![0]}
            </p>
            <p id="p-CalcPropsGeneralInfo-g">
                <label id="label-CalcPropsGeneralInfo-g">Timestamps: </label>
                {formatTimestamps(calculation.activeTimestamps)}
            </p>
            <p id="p-CalcPropsGeneralInfo-h">
                <label id="label-CalcPropsGeneralInfo-h">Vertex selection: </label>
                {formatVertexSelection(calculation.vertexSelection)}
            </p>
        </>
    );
};
